import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { AccountConfigState } from './AccountConfigState';
import { AccountConfigDisplay } from './AccountConfigDisplay/AccountConfigDisplay';
import { AccountConfigContainer, AccountConfigWrapper } from './AccountConfig.style';
import Loading from 'src/components/Loading';

interface AccountConfigPropsType {
    customerId: number;
}

export const AccountConfig = observer(({ customerId }: AccountConfigPropsType): JSX.Element => {
    const appState = useAppStateContext();
    const [state] = useState(() => new AccountConfigState(appState, customerId));

    useEffect(() => () => state.dispose(), [state]);

    return (
        <>
            <AccountConfigContainer>
                <AccountConfigWrapper>
                    <AccountConfigDisplay state={state} />
                </AccountConfigWrapper>
            </AccountConfigContainer>
            <Loading active={state.isLoading} />
        </>
    );
});
